import { useParams } from "react-router-dom";
import NotFound from "routes/404/Index";
import { useHasFeature } from "ui-library/HasFeature";
import useRequiresAdmin from "utils/useRequiresAdmin";
import { GenericListPage } from "./GenericListPage";
import { Integration } from "./Integration";
import { integrations } from "./integrations";

export function GenericIntegrationPage() {
	useRequiresAdmin();
	const { integrationType } = useParams();

	const integration = integrations.find(
		(integration) => integration.type === integrationType
	);

	const hasIntegration = useHasIntegration(integration);

	if (!integration || !hasIntegration) {
		return <NotFound />;
	}

	return <GenericListPage integration={integration} />;
}

function useHasIntegration(integration: Integration | undefined): boolean {
	// Running this through an array to handle the case where there isn't a feature flag
	const flags = integration?.featureFlag ? [integration?.featureFlag] : [];
	const [hasFeature] = useHasFeature(flags);

	if (!integration?.featureFlag) return true;
	return hasFeature;
}
